import { FetchAPI } from '@renedelangel/helpers';
import { urlServidor } from '../../helpers';

const CAMPOS = `
    seguimientoSeguroID
    tipoSeguimientoID
    empresaID
    empresa
    usuarioID
    ramoSeguimiento
    ejercicioID
    semanaAltaID
    estadoID
    estado
    descripcion
    numpolEndoso
    inciso
    folio
    fechaAlta
    fechaIngreso
    fechaSeguimiento
    personalSeguimiento
    responsableID
    avance
`;

export const ADD_SEGUIMIENTOSEGUROS = `
mutation addSeguimientoSeguros($input: InputAddSeguimientoSeguros!){
    addSeguimientoSeguros(input: $input){
        ${CAMPOS}
    }
}
`;

export const UPDATE_SEGUIMIENTOSEGUROS = `
mutation updateSeguimientoSeguros($input: InputUpdateSeguimientoSeguros!){
    updateSeguimientoSeguros(input: $input){
        ${CAMPOS}
    }
}
`;

export const DELETE_SEGUIMIENTOSEGUROS = `
mutation deleteSeguimientoSeguros($input: InputDeleteSeguimientoSeguros){
    deleteSeguimientoSeguros(input: $input)
}
`;

export const addSeguimientoSeguros = async (variables, token) => {
    try {
        let { addSeguimientoSeguros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: ADD_SEGUIMIENTOSEGUROS
        });
        return addSeguimientoSeguros;
    } catch ({ message }) { throw new Error(message); }
};

export const updateSeguimientoSeguros = async (variables, token) => {
    try {
        let { updateSeguimientoSeguros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: UPDATE_SEGUIMIENTOSEGUROS
        });
        return updateSeguimientoSeguros;
    } catch ({ message }) { throw new Error(message); }
};

export const GENERAR_SEGUIMIENTOS_PROGRAMA_ANUAL = `
mutation generarSeguimientosProgramaAnual($anio: Int!, $mes: Int!){
    generarSeguimientosProgramaAnual(anio: $anio, mes: $mes)
}
`;

export const generarSeguimientosProgramaAnual = async (variables, token) => {
    try {
        let { generarSeguimientosProgramaAnual } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GENERAR_SEGUIMIENTOS_PROGRAMA_ANUAL
        });
        return generarSeguimientosProgramaAnual;
    } catch ({ message }) { throw new Error(message); }
};

export const deleteSeguimientoSeguros = async (input, token) => {
    try {
        let { deleteSeguimientoSeguros } = await FetchAPI.graphql({
            token,
            variables: { input },
            url: urlServidor,
            query: DELETE_SEGUIMIENTOSEGUROS
        });
        return deleteSeguimientoSeguros;
    } catch ({ message }) { throw new Error(message); }
};
